<template>
	<div class="ap-header-wrap">
		<section class="ap-header">
			<div class="ap-actions ap-actions--left">
				<button type="button" class="theme_btn_dark" :disabled="uploading || locked"
					@click="uploadAllPlanAccounts">
					{{ uploading ? "Importando…" : "Importar" }}
				</button>
				<a class="download_btn" :href="`${hostname}/xlsx/${templateName}.xlsx`">
					<component :is="'DownloadFile'"></component>
					<span class="ml-1">Descargar Plantilla</span>
				</a>
				<input type="file" ref="fileInput" @change="(e) => uploadFilePlanAccounts(e)" accept=".xlsx,.xls"
					style="display: none" />
			</div>
			<h2 class="ap-title">Plan de Cuentas</h2>
			<div class="ap-actions ap-actions--right">
				<button v-if="hasRepeatedPlanAccount" type="button" class="theme_btn_red"
					:disabled="locked" @click="$emit('make-unique')">
					Hacer único
				</button>
				<button type="button" class="theme_btn_white" @click="$emit('export-accounts')">
					Exportar
				</button>
				<button v-if="needsReview" type="button" class="theme_btn_blue"
					@click="$emit('approve-review')">
					Completado
				</button>
				<!-- Candado (docs/decisiones §30): bloquea cualquier analista; quita
					el bloqueo solo el asignado a la empresa (can_unlock). -->
				<button v-if="!locked" type="button" class="theme_btn_white"
					@click="$emit('lock-plan')">
					Bloquear plan
				</button>
				<button v-else-if="canUnlock" type="button" class="theme_btn_red"
					@click="$emit('unlock-plan')">
					Quitar bloqueo
				</button>
			</div>
		</section>
		<p v-if="locked" class="ap-lock-badge" role="status">
			<span class="ap-lock-badge__dot" aria-hidden="true"></span>
			<span>
				<strong>Plan bloqueado</strong>{{ lockedAtLabel }}{{ lockedByLabel }}.
				<template v-if="!canUnlock">
					Solo el analista asignado puede quitar el bloqueo.
				</template>
			</span>
		</p>
	</div>
</template>

<script>
import moment from "moment";
import DownloadFile from "@/components/svg/DownloadFile.vue";

export default {
	name: "AccountPlanHeader",
	components: {
		DownloadFile,
	},
	props: {
		templateName: {
			type: String,
			default: "",
		},
		hasRepeatedPlanAccount: {
			type: Boolean,
			default: false,
		},
		needsReview: {
			type: Boolean,
			default: false,
		},
		uploading: {
			type: Boolean,
			default: false,
		},
		locked: {
			type: Boolean,
			default: false,
		},
		lockedAt: {
			type: String,
			default: "",
		},
		lockedByEmail: {
			type: String,
			default: "",
		},
		canUnlock: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		lockedAtLabel() {
			if (!this.lockedAt) return "";
			return ` el ${moment(this.lockedAt).format("DD/MM/YYYY HH:mm")}`;
		},
		lockedByLabel() {
			return this.lockedByEmail ? ` por ${this.lockedByEmail}` : "";
		},
		hostname() {
			const publicPath = window.location.hostname
			const localhost = ["localhost", "0.0.0.0"]
			if (localhost.includes(window.location.hostname)) {
				return `http://${publicPath}`;
			} else {
				return `https://${publicPath}`;
			}
		},
	},
	methods: {
		uploadAllPlanAccounts() {
			this.$refs.fileInput.click();
		},
		uploadFilePlanAccounts(e) {
			const file = e.target.files[0];
			e.target.value = null;
			if (!file) return;
			this.$emit("file-selected", file);
		},
	},
};
</script>
<style scoped lang="scss">
@use "./account_plan_buttons" as *;

.ap-header {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 44px;
	margin-bottom: 1.25rem;
}

// Badge del candado: una línea bajo el header, tono de advertencia suave.
.ap-lock-badge {
	display: flex;
	align-items: flex-start;
	gap: 0.5rem;
	margin: -0.5rem 0 1.25rem;
	padding: 0.5rem 0.75rem;
	border: 1px solid var(--ap-warn);
	border-radius: var(--ap-radius-sm);
	background: var(--ap-warn-wash);
	color: var(--ap-warn-ink);
	font-size: 13px;
	line-height: 20px;

	strong {
		color: inherit;
	}

	&__dot {
		flex-shrink: 0;
		width: 8px;
		height: 8px;
		margin-top: 6px;
		border-radius: 50%;
		background: var(--ap-warn);
	}
}

.ap-title {
	font-size: 1.2rem;
	font-weight: 700;
	color: var(--ap-ink);
	text-align: center;
}

.ap-actions {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&--left {
		left: 0;
	}

	&--right {
		right: 0;
	}
}

.download_btn {
	display: inline-flex;
	align-items: center;
	gap: 0.25rem;
	max-width: fit-content;
	padding: 8px 14px;
	border: 1px solid var(--ap-line-strong);
	border-radius: var(--ap-radius-sm);
	background: var(--ap-paper);
	color: var(--ap-ink-2);
	font-family: var(--ap-font);
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	text-decoration: none;
	transition: color 0.18s var(--ap-ease), border-color 0.18s var(--ap-ease);

	&:hover {
		color: var(--ap-teal);
		border-color: var(--ap-teal);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}
}
</style>
